// Campus photo for /colleges/university-of-virginia: CC BY 2.0, by Phil Roeder, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AThe_Rotunda_and_Lawn_University_of_Virginia_Charlottesville_VA_March_2011.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-virginia/; credited under the photo.
const photo = {
    "slug": "university-of-virginia",
    "alt": "The domed Rotunda at the head of the Lawn at the University of Virginia, with colonnaded pavilions and bare trees on either side",
    "src": "/colleges/university-of-virginia/campus-1600.webp",
    "srcSmall": "/colleges/university-of-virginia/campus-800.webp",
    "srcMid": "/colleges/university-of-virginia/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-virginia/og.jpg",
    "title": "The Rotunda and Lawn University of Virginia Charlottesville VA March 2011",
    "author": "Phil Roeder",
    "license": "CC BY 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AThe_Rotunda_and_Lawn_University_of_Virginia_Charlottesville_VA_March_2011.jpg",
    "read": "2026-10-01"
};

export default photo;
